(() => {
  if (window.nnClubFormsInstalled) return;
  window.nnClubFormsInstalled = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-nn-club-form]');
    if (!form) return;
    event.preventDefault();
    if (['true', 'done'].includes(form.dataset.sending) || !form.reportValidity()) return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-nn-status]');
    const email = form.elements.email.value.trim();
    const properties = {nn_signup_source: form.dataset.source, nn_signup_page: location.pathname, nn_launch: 'FW26 October 19'};
    if (form.dataset.product) {
      properties.nn_launch_product = form.dataset.product;
      properties.nn_launch_product_title = form.dataset.productTitle;
      const size = form.elements.preferred_size?.value;
      if (size) properties.nn_preferred_size = size;
    }
    const query = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
      const value = query.get(key);
      if (value) properties[key] = value.slice(0, 200);
    });
    form.dataset.sending = 'true';
    button.disabled = true;
    status.textContent = window.nnClubCopy.sending;
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=W3677i', {
        method: 'POST',
        headers: {'Content-Type': 'application/vnd.api+json', revision: '2025-07-15'},
        body: JSON.stringify({data: {type: 'subscription', attributes: {custom_source: 'NO NOISE ' + form.dataset.source, profile: {data: {type: 'profile', attributes: {email, properties}}}}, relationships: {list: {data: {type: 'list', id: 'TwhPnM'}}}}})
      });
      if (!response.ok) throw new Error('Signup failed');
      status.textContent = window.nnClubCopy.success;
      form.dataset.sending = 'done';
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', {$email: email}]);
      window._learnq.push(['track', 'Launch Signup Requested', properties]);
      form.dispatchEvent(new CustomEvent('nn:signup-requested', {bubbles: true, detail: {source: form.dataset.source}}));
    } catch {
      status.textContent = window.nnClubCopy.error;
      button.disabled = false;
      form.dataset.sending = 'false';
    }
  });
})();
